// Request Status Constants
export const REQUEST_STATUSES = {
  NEW: "New",
  IN_PROGRESS: "In Progress",
  ADDITIONAL_INFORMATION_RECEIVED: "Additional Information Received",
  ADDITIONAL_INFORMATION_REQUIRED: "Additional Information Required",
  UNDER_REVIEW: "Under Review",
  ESCALATED: "Escalated",
  ACTION_TAKEN: "Action Taken",
  NO_ACTION_TAKEN: "No Action Taken",
  PARTIAL_ACTION_TAKEN: "Partial Action Taken",
  PENDING_REVIEW: "Pending Review",
  REVIEWED: "Reviewed",
  DRAFT: "Draft",
  UNRESPONSIVE: "Unresponsive",
  // Add other request statuses here as needed
};

export const REQUEST_NOTES = {
  ADDITIONAL_DOCUMENTS_SUBMITTED: "Additional documents submitted.",
};

export const LINE_ITEM_STATUS = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  MODIFY: "Modify"
};

export const LENDER_REQUEST_CHANGE = { ADDED: "Added", REMOVED: "Removed" };

// --- Status Group Arrays ---
// These arrays are the single source of truth for classifying request statuses.
// When adding a new status to REQUEST_STATUSES, also add it to the appropriate group(s).

export const OPEN_STATUSES = [
  REQUEST_STATUSES.NEW,
  REQUEST_STATUSES.IN_PROGRESS,
  REQUEST_STATUSES.UNDER_REVIEW,
  REQUEST_STATUSES.PENDING_REVIEW,
  REQUEST_STATUSES.ESCALATED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_REQUIRED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED,
  REQUEST_STATUSES.UNRESPONSIVE,
];

export const CLOSED_STATUSES = [
  REQUEST_STATUSES.ACTION_TAKEN,
  REQUEST_STATUSES.NO_ACTION_TAKEN,
  REQUEST_STATUSES.PARTIAL_ACTION_TAKEN,
];

// Explicitly named for duplicate-request prevention documentation.
// The runtime duplicate-check hook still uses an exclusion rule
// (everything except CLOSED_STATUSES + Unresponsive) so that newly added
// statuses remain blocking by default until intentionally exempted.
export const DUPLICATE_REQUEST_BLOCKING_STATUSES = [
  REQUEST_STATUSES.DRAFT,
  REQUEST_STATUSES.REVIEWED,
  REQUEST_STATUSES.NEW,
  REQUEST_STATUSES.IN_PROGRESS,
  REQUEST_STATUSES.UNDER_REVIEW,
  REQUEST_STATUSES.PENDING_REVIEW,
  REQUEST_STATUSES.ESCALATED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_REQUIRED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED,
];

// Statuses grouped under the "In Progress Cases" card on the Dashboard
export const IN_PROGRESS_STATUSES = [
  REQUEST_STATUSES.UNDER_REVIEW,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_REQUIRED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED,
];

export const REVIEWABLE_STATUSES = [
  REQUEST_STATUSES.NEW,
  REQUEST_STATUSES.IN_PROGRESS,
  REQUEST_STATUSES.UNDER_REVIEW,
  REQUEST_STATUSES.PENDING_REVIEW,
  REQUEST_STATUSES.ESCALATED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED,
  REQUEST_STATUSES.UNRESPONSIVE,
];

export const LENDER_ACTIONABLE_STATUSES = [
  REQUEST_STATUSES.DRAFT,
  REQUEST_STATUSES.NEW,
  REQUEST_STATUSES.IN_PROGRESS,
  REQUEST_STATUSES.UNDER_REVIEW,
  REQUEST_STATUSES.PENDING_REVIEW,
  REQUEST_STATUSES.ESCALATED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_REQUIRED,
  REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED,
];

// --- Predicate Functions ---
export const isOpenStatus = (status) => OPEN_STATUSES.includes(status);
export const isClosedStatus = (status) => CLOSED_STATUSES.includes(status);
export const isReviewableStatus = (status) => REVIEWABLE_STATUSES.includes(status);
export const isLenderActionableStatus = (status) => LENDER_ACTIONABLE_STATUSES.includes(status);
export const isInProgressStatus = (status) => IN_PROGRESS_STATUSES.includes(status);